import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { FileImage } from '@/common/constants';
import { API_URL, IClaimAppealDocumentUploadResponseDto } from '@/dtos';
import { getFileInBlob } from '@/utils/modifiers';

interface Payload {
  claimId: string;
  file: FileImage;
}

const uploadAppealDocument = async ({ claimId, file }: Payload) => {
  const blob = await getFileInBlob(file.preview);
  const formData = new FormData();
  formData.append('file', blob as Blob, file.name || file.path);

  return api.post<IClaimAppealDocumentUploadResponseDto>(
    API_URL.CLAIMS_APPEAL_DOCUMENT_BY_CLAIM_ID(claimId),
    formData,
  );
};

const useUploadAppealDocumentQuery = () => {
  const { mutateAsync, isLoading } = useMutation(uploadAppealDocument);

  return {
    uploadAppealDocument: mutateAsync,
    isLoading,
  };
};

export default useUploadAppealDocumentQuery;